import style from './MapList.module.css'
import { TableSelect } from '../Select/TableSelect'
import { useEffect, useState } from 'react'
import { MapListItem } from '../../UI/TableItem/MapListItem'
import { useSelector, useDispatch } from 'react-redux'
import { setCablesFilter } from '../../Redux/Slices/Cables'
import { getCablesThunk } from '../../Redux/Slices/Cables/thunks'
import { openOrClose } from '../../Redux/Slices/Select/Select'

export function MapList() {
    const cables = useSelector((state) => state.cables.cables)
    const tags = useSelector((state) => state.cables.cablesTags)
    const activeTag = useSelector((state) => state.cables.cableActiveTag) 
    const vendorActiveTag = useSelector(state => state.vendor.vendorActiveTag)
    const TableSelectState = useSelector((state) => state.select.TableSelect)
    const [isOpen, setIsOpen] = useState(false)
    const dispatch = useDispatch()

    useEffect(() => {
        if(activeTag.id && vendorActiveTag.length > 0){
            dispatch(getCablesThunk({cable : activeTag.id, vendor : vendorActiveTag}))
        }
        // if(vendorActiveTag.id){
        //     dispatch(getCablesThunk({cable : null, vendor : vendorActiveTag.id}))
        // }
        else if(activeTag.id){
            dispatch(getCablesThunk({cable : activeTag.id,  vendor : vendorActiveTag }))
        }
        else {       
            dispatch(setCablesFilter([]))
        }
    }, [activeTag, vendorActiveTag, dispatch])

    return <div className={style.table}>
        <TableSelect options={tags} value={activeTag} isOpen={TableSelectState} setIsOpen={() => dispatch(openOrClose('TableSelect'))}/>
        <div className={`${style.table__body} ${style.active}`} >
            {cables.map((item, index) => <MapListItem key={index} data={item} />)}
        </div>
    </div>
}